export default {
    data() {
        return {};
    },
    methods: {
        notifyInfo(string = this.$t('title.item') ){
            this.$bvToast.toast(`${ string }`, {
                title: this.$t('common.info'),
                variant: 'info',
                solid: true,
            });
        },
        notifySuccess(string = this.$t('title.item')) {
            this.$bvToast.toast(`${ string } ${ this.$t('title.addSuccessfully') }`, {
                title: this.$t('common.success'),
                variant: 'success',
                solid: true,
            });
        },
        notifySuccessUpdate(string = this.$t('title.item')) {
            this.$bvToast.toast(`${ string } ${ this.$t('title.updateSuccessfully') }`, {
                title: this.$t('common.success'),
                variant: 'success',
                solid: true,
            });
        },
        notifySuccessWithMsg(description) {
            this.$bvToast.toast(`${ description }`, {
                title: this.$t('common.success'),
                variant: 'success',
                solid: true,
            });
        },
        notifyWarning(string = this.$t('title.item')) {
            this.$bvToast.toast(`${ string } ${ this.$t('title.updateSuccessfully') }`, {
                title: this.$t('common.warning'),
                variant: 'warning',
                solid: true
            });
        },
        notifyWarningWithMsg(description) {
            this.$bvToast.toast(`${ description }`, {
                title: this.$t('common.warning'),
                variant: 'warning',
                solid: true
            });
        },
        notifyError() {
            this.$bvToast.toast(`${ this.$t('title.errorMessage') }`, {
                variant: 'danger',
                solid: true
              });
        },
        notifyErrorWithMsg(description) {
            this.$bvToast.toast(`${ description }`, {
                variant: 'danger',
                solid: true
              });
        },
    }
};